import React from "react";
import "../CheckoutPanel/CheckoutPanel.css";

const SummaryHeader = () => (
  <div className="summary-header">
    <span>Product</span>
    <span>Quantity</span>
    <span>Price</span>
  </div>
);

export default SummaryHeader;
